import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import GoogleOneTap from '../Auth/GoogleOneTap';

export const LOGO_URL = `${process.env.REACT_APP_API_URL || 'https://api.air-brief.com'}/media/banners/Airworthy logo.png`;

export const Logo = ({ size = 'h-8 w-8', text = 'text-xl' }) => (
  <Link to="/" className="flex items-center gap-2" aria-label="AirBrief home">
    <img src={LOGO_URL} alt="" className={`${size} object-contain`} />
    <span className={`${text} font-semibold text-white`}>AirBrief</span>
  </Link>
);

// Top bar for the public pages. Signed-out visitors also get Google One Tap for quick sign-in.
const MarketingNav = ({ links = [] }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLink = 'text-sm text-gray-300 hover:text-white transition-colors';

  return (
    <>
    <GoogleOneTap />
    <nav className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${scrolled || open ? 'bg-slate-950/90 backdrop-blur-md border-b border-white/5' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <Logo />

          <div className="hidden lg:flex items-center gap-8">
            {links.map((l) => (l.href.startsWith('#')
              ? <a key={l.href} href={l.href} className={navLink}>{l.label}</a>
              : <Link key={l.href} to={l.href} className={navLink}>{l.label}</Link>))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link to="/login" className="px-3 py-2 text-sm font-medium text-gray-200 hover:text-white">Log in</Link>
            <Link to="/register" className="rounded-lg bg-primary-600 hover:bg-primary-500 px-4 py-2 text-sm font-semibold text-white transition-colors">Get started</Link>
          </div>

          <button
            type="button"
            onClick={() => setOpen(!open)}
            className="md:hidden -mr-2 p-2 text-white"
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
          >
            {open ? <XMarkIcon className="h-6 w-6" /> : <Bars3Icon className="h-6 w-6" />}
          </button>
        </div>

        {open && (
          <div className="md:hidden pb-5 space-y-4">
            <div className="flex flex-col">
              {links.map((l) => (l.href.startsWith('#')
                ? <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="py-2.5 text-gray-200">{l.label}</a>
                : <Link key={l.href} to={l.href} className="py-2.5 text-gray-200">{l.label}</Link>))}
            </div>
            <div className="grid grid-cols-2 gap-3">
              <Link to="/login" className="rounded-lg border border-white/20 py-3 text-center text-sm font-medium text-white">Log in</Link>
              <Link to="/register" className="rounded-lg bg-primary-600 py-3 text-center text-sm font-semibold text-white">Get started</Link>
            </div>
          </div>
        )}
      </div>
    </nav>
    </>
  );
};

export default MarketingNav;
